import { render, staticRenderFns } from "./SupplierQuotes.vue?vue&type=template&id=399145f4&"
import script from "./SupplierQuotes.vue?vue&type=script&lang=js&"
export * from "./SupplierQuotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports